import React from "react";
import { Redirect, Route, Router, Switch } from "wouter";
import { AdminLayout } from "./layouts/AdminLayout";
import { Dashboard } from "./pages/Dashboard";
import { LoginPage } from "./pages/auth/LoginPage";
import { EmpresasListPage } from "./pages/empresas/EmpresasListPage";
import { EmpresaNuevaPage } from "./pages/empresas/EmpresaNuevaPage";
import { EmpresaDetailPage } from "./pages/empresas/EmpresaDetailPage";
import { UserProvider, useUser } from "./contexts/UserContext";
import { Toaster } from "@/components/ui/sonner";

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useUser();
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-4 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Redirect to="/login" />;
  return <>{children}</>;
}

function App() {
  return (
    <UserProvider>
      <Router base="/">
        <Switch>
          <Route path="/login" component={LoginPage} />

          <Route>
            <PrivateRoute>
              <AdminLayout>
                <Switch>
                  <Route path="/" component={Dashboard} />
                  <Route path="/empresas" component={EmpresasListPage} />
                  <Route path="/empresas/nueva" component={EmpresaNuevaPage} />
                  <Route path="/empresas/:id" component={EmpresaDetailPage} />
                  <Route>
                    <div className="flex h-full items-center justify-center">
                      <div className="text-center">
                        <h1 className="text-4xl font-bold">404</h1>
                        <p className="text-muted-foreground">Página no encontrada</p>
                      </div>
                    </div>
                  </Route>
                </Switch>
              </AdminLayout>
            </PrivateRoute>
          </Route>
        </Switch>
      </Router>
      <Toaster />
    </UserProvider>
  );
}

export default App;
